import Vue from 'vue'

export default {
  filters: {
    dateFormat (value, vm) {
      let date = new Date(value)
      let options = {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
      }
      date.setHours(Math.abs(date.getTimezoneOffset() / 60))
      return date.toLocaleDateString(Vue.config.lang === 'en' ? 'en-UK' : Vue.config.lang, options)
    },
    currencyFormat (value, currency) {
      let formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: currency
      })
      return formatter.format(value)
    }
  },
  create () {
    Object.keys(this.filters).forEach(function (filter, k) {
      Vue.filter(filter, this.filters[filter])
    }.bind(this))
  }
}
